import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
  },
  getters:{
    isAuthenticated: (state) => state.isAuthenticated,
  },
  mutations: {
    setAuthentication(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
    },
  },
  actions: {
    async LogIn({commit}, user) {
      //await axios.post("login", user);
      if (user.get("password") === "POSITANO23"){
        await commit("setAuthentication");
      } else {
        throw new Error("Credentials not correct");
      }
    },

    async LogOut({ commit }) {
      commit("logout");
    },
  },
  modules: {
  }
})
